export default "__VITE_ASSET__CgrFOoer__"